import { AppLayout } from "@ui/Organisms/Layout/AppLayout";
import type * as React from "react";
import type { LegalSection, LegalTemplateTranslations } from "./types";

export type { LegalSection, LegalTemplateTranslations };

type Props = {
	nav: React.ReactNode;
	footer: React.ReactNode;
	title: string;
	lastUpdated: string;
	sections: LegalSection[];
	translations: LegalTemplateTranslations;
};

export function LegalTemplate({
	nav,
	footer,
	title,
	lastUpdated,
	sections,
	translations,
}: Props) {
	return (
		<AppLayout nav={nav} footer={footer}>
			<div
				style={{
					maxWidth: 720,
					margin: "0 auto",
					padding: "48px 28px",
					width: "100%",
				}}
			>
				<h1
					style={{
						margin: "0 0 6px",
						fontSize: "clamp(28px, 5vw, 40px)",
						fontWeight: 800,
						letterSpacing: "-0.025em",
						color: "var(--content-primary)",
					}}
				>
					{title}
				</h1>
				<div
					style={{
						fontSize: 13,
						color: "var(--content-muted)",
						marginBottom: 36,
					}}
				>
					{lastUpdated}
				</div>

				<div
					style={{
						background: "var(--surface-default)",
						border: "1px solid var(--border-subtle)",
						borderRadius: "var(--radius-md)",
						padding: "18px 22px",
						marginBottom: 36,
					}}
				>
					<h4
						style={{
							margin: "0 0 10px",
							fontSize: 11,
							letterSpacing: "0.1em",
							textTransform: "uppercase",
							color: "var(--content-muted)",
							fontWeight: 700,
						}}
					>
						{translations.tocHeading}
					</h4>
					<ol style={{ margin: 0, paddingLeft: 20 }}>
						{sections.map((s) => (
							<li
								key={s.heading}
								style={{
									padding: "3px 0",
									fontSize: 14,
									color: "var(--content-primary)",
								}}
							>
								{s.heading}
							</li>
						))}
					</ol>
				</div>

				{sections.map((s) => (
					<div key={s.heading}>
						<h2
							style={{
								fontSize: 20,
								fontWeight: 700,
								letterSpacing: "-0.015em",
								margin: "32px 0 10px",
								color: "var(--content-primary)",
							}}
						>
							{s.heading}
						</h2>
						{Array.isArray(s.content) ? (
							s.content.map((p, i) => (
								<p
									// biome-ignore lint/suspicious/noArrayIndexKey: static legal copy, paragraphs never reorder
									key={i}
									style={{
										margin: "0 0 12px",
										fontSize: 15,
										lineHeight: 1.65,
										color: "var(--content-secondary)",
									}}
								>
									{p}
								</p>
							))
						) : (
							<p
								style={{
									margin: 0,
									fontSize: 15,
									lineHeight: 1.65,
									color: "var(--content-secondary)",
								}}
							>
								{s.content}
							</p>
						)}
					</div>
				))}
			</div>
		</AppLayout>
	);
}
